import Image from 'next/image'
import patriaLogo from './patria.png'

type IconProps = {
  className?: string
}

const PatriaLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={patriaLogo} alt="PATRIA Logo" height={48} {...attributes} />
}

export default PatriaLogo
